import { render, staticRenderFns } from "./PbxCall.vue?vue&type=template&id=20e2ad58&scoped=true"
import script from "./PbxCall.vue?vue&type=script&lang=js"
export * from "./PbxCall.vue?vue&type=script&lang=js"
import style0 from "./PbxCall.vue?vue&type=style&index=0&id=20e2ad58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2ad58",
  null
  
)

export default component.exports